import { FlatList } from 'react-native';

export const AnimatedFlatList = FlatList;
